import React, { Component } from 'react';
import Sticky from 'Components/Sticky';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { FETCH_SEEKER_BIDS } from 'Constants/actionConstants';
import { RFQ_DISPLAY_LIMIT } from 'Constants/commonConstants';
// import KPTLImg from 'Icons/kptl-logo.png';
import LogoImg from 'Icons/Logo.jpg';
import Pdf from "react-to-pdf";

const pdfRef = React.createRef();

class ComparativeFormat extends Component {
    constructor(){
        super();
        this.state = {

        }
    }

    componentDidMount() {
        this.getSeekerBids();
    }

    getSeekerBids = () => {
		const { dispatch, match } = this.props;
		dispatch({
			type: FETCH_SEEKER_BIDS,
			params: {
				rfqId: match.params.id,
				rfqType: match.params.type,
				limit: RFQ_DISPLAY_LIMIT
			}
        })
	}

    getDetails = () => {
        const { trips } = this.props;
        const vendorTotal = {};
        return (
            <>
                <div className={'col-1 ph-20 flex flex-middle'}>
                    <div className={'col-2 inBlock'}>
                        <img src={LogoImg} alt="" width='300' className={'ml-10'} height={'100'}/>
                    </div>
                    <div className={'col-2 inBlock tCenter'}>
                        {/* <div className={'fBold fs-16'}>{'KALPATARU POWER TRANSMISSION LTD.'}</div>
                        <div className={'mt-5 fs-14'}>Immeuble Hajal Massad Centre, 3rd Floor</div>
                        <div className={'mt-5 fs-14'}>Chambre 302 / 303, Carrefour Warda,</div>
                        <div className={'mt-5 fs-14'}>Yaounde, Republic of Cameroon</div> */}
                        <div className={'fBold fs-16'}>{'ABC LTD.'}</div>
                        <div className={'mt-5 fs-14'}>Bangalore, Karnataka, India</div>
                    </div>
                </div>
                {(trips || []).length > 0 && <div className="mt-20 ph-20 pr-table">
                    <table cellPadding="0" cellSpacing="0">
                        <thead>
                        <tr>
                            <th>Sr No.</th>
                            <th>Description</th>
                            <th>UOM</th>
                            <th>Quantity</th>
                            {
                                (trips[0] || {}).vendor_name.map(vendor => (
                                    <th>{vendor.name}</th>
                                ))
                            }
                            <th style={{ 'borderRight': '1px solid grey'}}>LPP</th>
                        </tr>
                        </thead>
                        <tbody>
                        {(trips || []).map((trip, tripIndex) => 
                        (<tr key={tripIndex}>
                            <td>{tripIndex + 1}</td>
                            <td>{trip.material_code_description || 0}</td>
                            <td>{trip.uom || 0}</td>
                            <td>{trip.total_estimated_qty || 0}</td>
                            {
                                (trips[0] || {}).vendor_name.map(vendor => {
                                    const bid = (trip.bids || []).find(bid => bid.transporterId === vendor.id) || {};
                                    vendorTotal[bid.transporterId] = Number(bid.price || 0) + (vendorTotal[bid.transporterId] || 0);
                                    return <td>{bid.price || '-'}</td>
                                })
                            }
                            <td style={{ 'borderRight': '1px solid grey'}}>{trip.lpp || 0}</td>
                        </tr>))}
                        <tr>
                            <th colSpan="4">Total</th>
                            {
                                (trips[0] || {}).vendor_name.map(vendor => {
                                    return <td>{vendorTotal[vendor.id] || '0'}</td>
                                })
                            }
                            <td style={{ 'borderRight': '1px solid grey'}}>{(trips || []).reduce((sum, trip) => sum += Number(trip.lpp || 0), 0)}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>}
            </>
        )
    }

    render() {
        const { rfq, trips } = this.props;
        const vendorTotal = {};
        return (
            <Sticky>
                {rfq && <Link className="ht-40 flex pl-40 wt-200 pt-10" to={"/seeker/bids/" + rfq.id + "/" + rfq.type}>
                    <BackIcon className="mr-10 fill-theme curP"/>
                    <div className="header-dark-color fs-16 fBold">{rfq.rfqDetails.name}</div>
                </Link>}
                <div className={'pv-20 mr-20 ml-20  box-shadow'} >
                    {this.getDetails()}
                </div>
                <div className="pl-40 pf col-1 b-0 ht-60 box-shadow bg-white z-6">
                    <div className="flex flex-middle flex-between ht-60">
                        <Pdf targetRef={pdfRef} filename="comparative_format.pdf" options={{
                            orientation: 'landscape'
                        }}>
                            {({ toPdf }) => <button className={"ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30"} onClick={toPdf}>Download Comparative Format</button>}
                        </Pdf>
                    </div>
                    {<div style={{'width': '87%'}} ref={pdfRef}>
                        {this.getDetails()}
                    </div>}
                </div>
            </Sticky>
        )
    }
}

const mapStateToProps = ({ rfq }) => {
    return {
        trips: rfq.seekerBids.trips,
        rfq: rfq.seekerBids.data
    }
}

export default connect(mapStateToProps)(ComparativeFormat);
